<template>
<div>
  <v-main class="py-2 px-2">
    <!-- *************DADOS GERAIS DA UNIDADE********************** -->
    <v-layout row wrap>
      <v-flex xs12 sm6 class="pl-2 pt-2 pr-2">
         <v-flex xs12 sm6 class="pt-1">
         
            <v-card flat outlined class="rounded-xl">
                <v-card-title>Espera até recepcionista:</v-card-title>
              <!-- <v-toolbar card dense flat>
                <v-toolbar-title  class="pa-0">
                  <span class="subheading pa-0"> </span>
                </v-toolbar-title>
                <v-spacer></v-spacer>
              </v-toolbar> -->
              <v-card-text>
                <span
                class="display-1 font-weight-light"
                >{{tempoEspera}}</span> (min)
                      </v-card-text>
                    </v-card>
                </v-flex>
          </v-flex>
        </v-layout>

    <!-- ***************************TABELAS************************ -->

  </v-main>
</div>
</template>

<script>

export default {
  name: 'funcionariosOnline',

  data: (vm) => ({
    valid: true,
    quantAtendimentos: 0,
    mediaAtendimentoUnidade: 0
  }),

  props: {
    msg: String,
    tempoEspera: String
  },
  mounted () {
    console.log('em servicos unidade...')
    this.user = this.$store.getters.usuario
    // EventBus.$on('carregarTempoEspera', this.carregarTempoEspera)
  },

  methods: {

    formatarTempo (tempo) {
      var a = tempo.split(':')
    },

    calculaMediaAtendimentoUnidade (lista) {
      if (!lista.length) {
        return 0
      }
      var produto = 0
      var somaAtendimentos = 0
      lista.forEach((element) => {
        somaAtendimentos = somaAtendimentos + element.quantAtendimentos
        var hms = element.mediaAtendimento // your input string
        var a = hms.split(':') // split it at the colons
        var seconds = +a[0] * 60 * 60 + +a[1] * 60 + +a[2]
        var newSeconds = element.quantAtendimentos * seconds
        produto = produto + newSeconds
      })
      var result = produto / somaAtendimentos
      var date = new Date(result * 1000)
      var hh = date.getUTCHours()
      var mm = date.getUTCMinutes()
      var ss = date.getSeconds()
      // If you were building a timestamp instead of a duration, you would uncomment the following line to get 12-hour (not 24) time
      // if (hh > 12) {hh = hh % 12;}
      // These lines ensure you have two-digits
      if (hh < 10) {
        hh = '0' + hh
      }
      if (mm < 10) {
        mm = '0' + mm
      }
      if (ss < 10) {
        ss = '0' + ss
      }
      // This formats your string to HH:MM:SS
      var t = hh + ':' + mm + ':' + ss
      return t
    },

    converterDate (data) {
      if (data == '---') {
        return '---'
      } else {
        var d = new Date(data)
        var dia = d.getDate().toString()
        var diaF = dia.length == 1 ? '0' + dia : dia
        var mes = (d.getMonth() + 1).toString() // +1 pois no getMonth Janeiro começa com zero.
        var mesF = mes.length == 1 ? '0' + mes : mes
        var anoF = d.getFullYear()

        return diaF + '/' + mesF + '/' + anoF
      }
    }
  },
  computed: {

  },

  created () {
    console.log('created...')
  }
}
</script>

<style scoped>
.md-card {
  width: 320px;
  margin: 4px;
  display: inline-block;
  vertical-align: top;
}

.feedback {
  background-color: #31b0d5;
  color: white;
  padding: 10px 20px;
  border-radius: 4px;
  border-color: #46b8da;
}

#mybutton {
  position: fixed;
  bottom: 20px;
  right: 10px;
}
.input-qty {
  width: 60px;
  height: 25px;
  border: 2px solid #80cbc4;
  border-radius: 5px;
}

.rounded-card {
  border-radius: 35px;
}
</style>
